import { createRouter, createWebHistory } from 'vue-router';

//// Layouts
import AuthLayout from '@/layouts/AuthLayout.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import HomeLayout from '@/layouts/HomeLayout.vue';

//// Screens
// Auth
import SignUp from '@/views/auth/SignUp.vue';
import Login from '@/views/auth/Login.vue';
import PasswordReset from '@/views/auth/PasswordReset.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';

// Dashboard
import Documents from '@/views/dashboard/Documents.vue';
import Trash from '@/views/dashboard/Trash.vue';
import Account from '@/views/dashboard/Account.vue';
import Support from '@/views/dashboard/Support.vue';
import Products from '@/views/dashboard/Products.vue';

// Modules
import Functions from '@/views/home/Functions.vue';

import { usePayloadStore } from '@/stores/payload';
import { checkToken } from '@/actions/auth';

const isAuthenticated = (to: any, from: any, next: any) => {
  const payloadStore = usePayloadStore();
  if (payloadStore?.payload?.token) {
    checkToken()
      .then(() => {
        next('/dashboard/documents');
      })
      .catch((err) => {
        console.log(err);
        payloadStore.clear();
      });
  } else {
    next();
  }
};

const authenticated = (to: any, from: any, next: any) => {
  const payloadStore = usePayloadStore();
  if (!payloadStore?.payload?.token) {
    payloadStore.clear();
    window.location.href = '/accounts/login/';
  }
  checkToken()
    .then(() => {
      next();
    })
    .catch((err) => {
      payloadStore.clear();
      window.location.href = '/accounts/login/';
    });
};

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/accounts/login' },
    {
      path: '/accounts',
      name: 'accounts',
      component: AuthLayout,
      children: [
        {
          path: '/accounts/login',
          component: Login,
          beforeEnter: isAuthenticated
        },
        {
          path: '/accounts/password_reset',
          component: PasswordReset
        },
        {
          path: '/accounts/new-password/:token',
          component: ResetPassword
        }
      ]
    },
    {
      path: '/dashboard',
      name: 'documents',
      redirect: '/dashboard/documents',
      component: DashboardLayout,
      beforeEnter: authenticated,
      children: [
        {
          name: 'My Documents',
          path: '/dashboard/documents',
          component: Documents
        },
        {
          name: 'Trash',
          path: '/dashboard/trash',
          component: Trash
        },
        {
          name: 'My Account',
          path: '/dashboard/account',
          component: Account
        },
        {
          name: 'Support',
          path: '/dashboard/support',
          component: Support
        },
        {
          name: 'Products',
          path: '/dashboard/products',
          component: Products
        }
      ]
    },
    {
      path: '/home',
      name: 'functions',
      alias: '/',
      component: HomeLayout,
      beforeEnter: authenticated,
      children: [
        {
          path: 'functions',
          component: Functions
        }
      ]
    },
    {
      path: '/signup',
      name: 'signup',
      alias: '/',
      component: AuthLayout,
      children: [
        {
          path: '',
          component: SignUp,
          beforeEnter: isAuthenticated
        }
      ]
    }
  ]
});

export default router;
